<template>
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">新增病歷</h5>
            <heardOptionView :options="options"></heardOptionView>
        </div>
        <div class="card-body">
            <formsView
                :mode="'create'"
                v-model="formData"
                :acknowledgmentList="acknowledgmentList"
                @getIntakeData="setIntakeData"
            ></formsView>            
        </div>
    </div>
</template>
<script>
import formsView from '@/views/dev/healthRecord/formView.vue'
import heardOptionView from '@/components/heardOptionView.vue'
export default {
    name:'healthRecord-create',
    components: {
        formsView,heardOptionView
    },
    props:{
        acknowledgmentList:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        const userData = this.$api.users.getUserData()
        const userPermission = this.$api.users.getUserPermission()
        return {
            
            options:[
                {
                    title:'儲存',
                    btnColor:'btn-success',
                    icon:'fas fa-fw fa-save',
                    clickHandle:this.save
                }
            ],
            formData:{
                medical_record_id:null,
                medical_record_sn:'',
                acknowledgment_id:null,
                main_doctor: userPermission.is_mainDoctor == 1 ? userData.id : -1,
                species_category_id:-1,
                species_id:-1,
                tracking_device_sn:'',
                alias_name:'',
                characteristics:'',
                gender_id:0,
                pregnancy_status:1,
                location_id:-1,
                latest_weight:0.0,
                create_time:'2026-01-20 11:42:06',
                admission_date:'2026-01-20',
                rescue_reason_id:-1,
                rescue_reason_note:'',
            }
        }
    },
    methods:{
        async save(){
            let objFrom = new FormData()
            objFrom.append('acknowledgment_id',this.formData.acknowledgment_id)    
            objFrom.append('serial_no' , this.formData.serial_no)
            objFrom.append('main_doctor',this.formData.main_doctor)
            objFrom.append('species_category_id', this.formData.species_category_id)
            objFrom.append('species_id',this.formData.species_id)
            objFrom.append('tracking_device_sn',this.formData.tracking_device_sn)
            objFrom.append('alias_name',this.formData.alias_name)
            objFrom.append('characteristics',this.formData.characteristics)
            objFrom.append('gender_id',this.formData.gender_id)
            objFrom.append('pregnancy_status',this.formData.pregnancy_status)
            objFrom.append('location_id',this.formData.location_id)
            objFrom.append('latest_weight',this.formData.latest_weight)
            objFrom.append('status_id',this.formData.status_id)
            this.$store.state.loadingStatus = true
            const res = await this.$api.medical.importMedicalrecord(objFrom)
            this.$store.state.loadingStatus = false
            console.log(res)
        },
        setIntakeData(data){
            this.formData.serial_no = data.acknowledgment_serial_no
            this.formData.admission_date = data.accept_date
        }
    }
}
</script>